import axios from 'axios';

export default {
  url: function () {
    return process.env.VUE_APP_API_URL;
  },
  sessionId: function (){
    // return sessionStorage.getItem('session_id') ?? '203091';
    return (window.session_id == undefined) ? '203091' : window.session_id;
  },
  token:function(){
    return window.token === undefined ? '98CE7937-EE73-8053-9B23-E388E5FC8E9E' : window.token;
  },
  checkExecutionErrorVue: function (response) {
    return response['Response']['ExecutionError']['ExecutionErrorCode'] === 0;
  },
  checkErrorCodeVue: function (response) {
    if (response === null) {
      //что то отъебнулось закрываем запрос если повезло с null
      return {result: false, reload: false};
    }
    if (response.Error['ErrorCode'] < 0) {
      // ошибки из фракции полный пипец
      return {result: false, reload: false};
    }
    if (response.Error['ErrorCode'] > 0) {
      // ошибки которые могут пройти если немного подождать
      return {result: true, reload: true};
    }
    if (response.Error['ErrorCode'] === 0) {
      // все збс
      let responeResult = true;
      if (response.hasOwnProperty('Response')) {
        responeResult = this.checkExecutionErrorVue(response);
      }
      if (responeResult) {
        return {result: true, reload: false};
      } else {
        return {result: false, reload: false};
      }
    }
    return {result: false, reload: false}
  },
  SendRequest: function (sendData) {
    return new Promise((resolve, reject) => {
      let self = this;
      sendData['Session_id'] = this.sessionId();
      axios({
        method: 'post',
        url: this.url(),
        data: sendData,
      }).then(function (response) {
        // debugger;
        let checkResult = self.checkErrorCodeVue(response.data);
        if (checkResult.result) {
          if (checkResult.reload) {
            const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
            wait(500).then(() => {
              self.SendRequest(sendData)
              .then((res) => {
                resolve(res)
              })
              .catch((res) => {
                reject(res)
              });
            });
          } else {
            self.GetRequestResult(response.data['RequestID'])
            .then((res) => {
              resolve(res)
            })
            .catch((res) => {
              reject(res)
            });
          }
        } else {
          reject(response.data);
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
  GetRequestResult: function (ExecuteGUID) {

    return new Promise((resolve, reject) => {
      let self = this;
      let sendData = {
          ExecuteGUID: ExecuteGUID,
          action: 'iks_GetQuery'
        }
      ;
      sendData['Session_id'] = this.sessionId();

      axios({
        method: 'post',
        url: this.url(),
        data: sendData,
      }).then(function (response) {
        let checkResult = self.checkErrorCodeVue(response.data, 'getResultSaveForm');
        if (checkResult.result) {
          if (checkResult.reload) {
            const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
            wait(500).then(() => {
              self.GetRequestResult(ExecuteGUID)
              .then((res) => {
                resolve(res);
              })
              .catch((res) => {
                reject(res)
              });
            });
          } else {
            resolve(response.data['Response']['ExecutionResult']);
          }
        } else {
          reject(response.data);
        }
      }).catch((resp) => {
        if (resp.data !== undefined) {
          reject(resp.data);
        } else {
          reject(resp);
        }
      });
    });
  },
  singleRequest: function (sendData) {
    return new Promise((resolve, reject) => {
      sendData['Session_id'] = this.sessionId();
      axios({
        method: 'post',
        url: this.url(),
        data: sendData
      }).then((resp) => {

        try {

          if (resp.data.Response.ExecutionResult !== undefined) {
            resolve(resp.data.Response.ExecutionResult);
          } else {
            reject(resp.data);
          }
        } catch (resp) {
          reject(resp.data);
        }
      }).catch((resp) => {

        if (resp.data !== undefined) {
          reject(resp.data);
        } else {
          reject(resp);
        }
      });
    });
  },
  singleRequestUps: function (sendData) {
    return new Promise((resolve, reject) => {
      sendData['Session_id'] = this.sessionId();
      axios({
        method: 'post',
        url: this.url(),
        data: sendData
      }).then((resp) => {
        
        try {
          
          if (resp.data.ExecutionResult !== undefined) {
            resolve(resp.data.ExecutionResult);
          } else {
            reject(resp.data);
          }
        } catch (error) {
          console.log(error)
          reject(resp.data);
        }
      }).catch((resp) => {
        
        if (resp.data !== undefined) {
          reject(resp.data);
        } else {
          reject(resp);
        }
      });
    });
  },
  checkVersion: function () {
    return new Promise((resolve, reject) => {
      let sendData = {
        Session_id: this.sessionId(),
        action: 'checkVersion'
      };

      this.singleRequest(sendData).then((res) => {
        if (localStorage.getItem('cache') === null) {
          localStorage.setItem('cache', res.cache)
        } else if (parseInt(localStorage.getItem('cache'), 10) !== res.cache) {
          localStorage.setItem('cache', res.cache);
          document.location.reload();
          reject();
        }
        resolve();
      })
      .catch((res) => {
        reject(res);
      });
    });
  },
  suggestResult: function (action,queryValue){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:process.env.VUE_APP_URL_SUGGESTIONS + action,
        data:{
          action:action,
          searchStuff: queryValue,
        }
      }).then((resp)=>{
        try {
          resolve(resp);
        } catch (e) {
          reject();
        }
      }).catch(()=>{
        reject();
      });
    });
  },
  suggestResultGigData: function (query, count){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url: process.env.VUE_APP_API_URL_GIG_DATA,
        headers: {
          'Content-Type': 'application/json',
          'authorization': process.env.VUE_APP_API_URL_GIG_DATA_TOKEN,
        },
        data:{
          query,
          count,
        }
      }).then((resp)=>{
        try {
          resolve(resp);
        } catch (e) {
          reject();
        }
      }).catch(()=>{
        reject();
      });
    });
  },
  suggestWorkData: function (value){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url: process.env.VUE_APP_URL_SUGG_WORK,
        data: value,
      }).then((res)=>{
        try {
          resolve(res.data.suggestions);
        } catch (e) {
          reject();
        }
      }).catch(()=>{
        reject();
      });
    });
  },
  upsResponseBroken: function(objError, fromAction, e = {message:''}){
    //заявку можно завести с особым статусом
    axios({
      method: 'post',
      url: this.url(),
      data: {
        action: 'iksBroken',
        Session_id: this.sessionId(),
      }
    });
    //логируем что за херня случилась
    axios({
      method: 'post',
      url: this.url(),
      data: {
        action: 'logError',
        from: 'admd',
        catchAction: fromAction,
        catchMsg: e.message,
        result: JSON.stringify(objError),
        Session_id: this.sessionId(),
      }
    });
    return {
      ExecutionErrorCode: 0,
      ExecutionErrorMessage: 'Мы отследили эту ошибку и уже исправляем. Попробуйте позже.',
    }
  },
  parseError: function (objError, fromAction) {
    try {
      if (objError.Error.ErrorCode < 0) {
        //что то пошло по пиз** пишем в лог, даем зеленый свет на заведение заявки с особым статусом
        return this.upsResponseBroken(objError, fromAction, '');
      }
      //возрашаем нормальный код ошибки и сообщение об ошибке из икса
      return {
        ExecutionErrorCode: objError.Response.ExecutionError.ExecutionErrorCode,
        ExecutionErrorMessage: objError.Response.ExecutionError.ExecutionErrorMessage,
      }
    } catch (e) {
      //совсем все пошло по пиз** пишем в лог, даем зеленый свет на заведение заявки с особым статусом
      return this.upsResponseBroken(objError, fromAction, e);
    }
  },
  trackUrl:function (sendData,url){
    return new Promise((resolve)=>{
      sendData['Session_id'] = this.sessionId();
      sendData['token'] = this.token();
      axios({
        method: 'post',
        url: process.env.VUE_APP_URL_API.toString() + url.toString(),
        data: sendData
      }).then(()=>{
        resolve(true);
      }).catch(()=>{
        resolve(false)
      });
    });
  },
  smartId: async function (image64) {
    try {
      const result = await axios({
        method: 'POST',
        url: process.env.VUE_APP_URL_API + 'smartID.php',
        data: {
          file: image64,
          session: window.session_id
        }
      });
      return result?.data;
    } catch (error) {
      return error.message;
    }
  },
  saveFile: async function (image64) {
    try {
      const result = await axios({
        method: 'POST',
        url: process.env.VUE_APP_URL_API + 'addScan.php',
        data: {
          file: image64,
          Session_id: this.sessionId(),
          token:  this.token()
        }
      });
      return result?.data;
    } catch (error) {
      return error.message;
    }
  }
}
